import { useAppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useCmsText } from '../../hooks/useCmsText';

const Questions = () => {
  const { state } = useAppContext();
  const { renderPlainText: renderText  } = useCmsText();
  const navigate = useNavigate();

  const handleBackToStart = () => {
    if (state.partnerName) {
      navigate(`/?partner=${state.partnerName}`);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="w-full flex flex-col px-4 mt-10 justify-center">
      <h1 className="text-lg font-semibold text-primary" style={{ color: state.branding?.fontColor }}>{renderText('response_screen_bold_2')}</h1>
      <p className="text-md font-normal mt-2" style={{ color: state.branding?.fontColor }}>{state.partnerName ? `E-post: ${renderText('response_screen_email')} og Telefonnummer: ${renderText('response_screen_phone')} ` : "Har du spørsmål om analysen eller svaret du fikk? Svar på denne meldingen eller kontakt "}
        {!state.partnerName && <a href="mailto:hei@skjold.ai" className="text-primary font-medium underline">
          hei@skjold.ai
        </a>}
      </p>
      <button onClick={handleBackToStart} className="w-full text-sm font-medium text-primary mt-10 border border-primary rounded-xl px-5 py-3" style={{ color: state.branding?.fontColor }}>
        {renderText('result_button_check_new', 'Sjekk ny melding')}
      </button>
    </div>
  )
}

export default Questions;